import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from "@mui/material";

interface Props {
  visible: boolean;
  onSubmitted: () => void;
  onCancelled: () => void;
}

const CreatePerformanceFeedbackModal = (props: Props) => {
  return (
    <Dialog open={props.visible} onClose={props.onCancelled}>
      <DialogTitle>Performance Feedback</DialogTitle>
      <DialogContent>Form here.</DialogContent>
      <DialogActions>
        <Stack direction="row" spacing={1} sx={{ justifyContent: "space-between", width: "100%" }}>
          <Stack direction="row" sx={{ width: "100%" }}>
            <Button variant="outlined" onClick={props.onCancelled}>
              Cancel
            </Button>
            <Button variant="outlined" onClick={props.onSubmitted} sx={{ ml: "20px !important" }}>
              Save Draft
            </Button>
          </Stack>
          <Button variant="contained" onClick={props.onSubmitted}>
            Submit
          </Button>
        </Stack>
      </DialogActions>
    </Dialog>
  );
};

export { CreatePerformanceFeedbackModal };
